import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class NotificationApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public get(pageEvent) {
    let endpoint = 'notification-admin/notifications';
    const url = this.commonFunctionService.findApiUrl('notification-admin');
    if (pageEvent) {
      endpoint += `?pageIndex=${pageEvent.pageIndex}&pageSize=${pageEvent.pageSize}`;
    }
    return this.Api.get(endpoint, url);
  }

  public send(notification) {
    let endpoint = 'notification-admin/notification';
    const url = this.commonFunctionService.findApiUrl('notification-admin');
    return this.Api.post(endpoint, notification, url);
  }
}
